import { PointsAccountingException } from '@/domain/points/accounting/exception/PointsAccountingException'

export class UnknownPointsAccountingException extends PointsAccountingException {

}
